import _ from 'lodash';
import {
  activeStatus,
  userType,
  TRAVELER_TYPE,
} from '../../../constants/commondata';
import { LOG_BOOK_PAYMENT_FUNC_FILE } from '../../../utils/ccLoger/ccLoger.helper';

export const PM_ONLY_BOOK_FROM_APP = [9, 13, 21, 23, 27, 28, 29, 30, 31, 32, 33, 34];

export const handleWalletName = (name) => {
  // if(name === 'alipay') return 'Alipay Wallet'
  return name
}

export const filterCreditCardByGateway = ({
  credits = [],
  multiGateway,
  gatewaysByPickupZone,
  fleetConfigGateway,
}) => {
  if(multiGateway) {
    return credits.filter((credit) => {
      return gatewaysByPickupZone?.gateway === credit?.gateway
    })
  }
  return credits.filter((credit) => (
    fleetConfigGateway?.gateway === credit?.gateway
  ))
}

export const handlePaymentType_21_bookDetail = ({
  listPayment,
  gatewayName,
  booking
}) => {
  let pmFinal = listPayment?.filter((pm) => {
    if(pm.value !== 21) return true;
    let name = pm.name.toUpperCase();
    return name.toUpperCase() === gatewayName.toUpperCase()
  })
  if(booking?.request?.paymentType === 21 && booking?.request?.gateway === 'Xendit' && booking?.request?.walletName === 'QRIS') {
    pmFinal.push({
      value: 21,
      name: 'QRIS',
      key: 'QRIS',
      type: 'paxWallet',
    })
  }
  return pmFinal;
}

function isPaymentMethodEditable(booking, is3rdBooking, isFarmInHydraPendingStatus) {
  let status = activeStatus.filter((data) => {
    return data.code == booking.status;
  })[0];
  if (is3rdBooking) return false;
  if (isFarmInHydraPendingStatus) return false;
  if (!booking.pricingType) {
    return status && status.paymentMethodEditable;
  } else if (!booking.farmOut) {
    return status && status.paymentMethodEditable;
  }
  return false;
}

const calulatePreAuthoried = (data) => {
  const authAmount = data?.preAuthorized?.authAmount || 0;
  const additionalPreauths = (
    data?.preAuthorized?.additionalPreauths || []
  ).reduce(
    (accumulator, currentValue) => accumulator + currentValue.addlAmount,
    0
  );
  return authAmount + additionalPreauths;
};

const checkAllShowOnlinePayment = (data = {}) => {
  const paymentType = data?.request?.paymentType;
  if (
    (data?.preAuthorized?.authAmount > 0 || data.paidAmount > 0) &&
    PM_ONLY_BOOK_FROM_APP.includes(paymentType)
  )
    return true;
  return false;
};

export const checkRemoveOnlineMethodBookForm = (
  paymentType
) => {
  if(PM_ONLY_BOOK_FROM_APP.includes(paymentType)) {
    return PM_ONLY_BOOK_FROM_APP.filter((pm) => pm !== paymentType);
  }
  return PM_ONLY_BOOK_FROM_APP;
};

export const checkRemoveOnlineMethodCompleteForm = (
  paymentType,
  isAllwayShowOnlineMethod,
  PM_ONLY_BOOK_FROM_APP_COMPLETED_DRIVER
) => {
  if(PM_ONLY_BOOK_FROM_APP_COMPLETED_DRIVER.includes(paymentType) && isAllwayShowOnlineMethod) {
    return PM_ONLY_BOOK_FROM_APP_COMPLETED_DRIVER.filter((pm) => pm !== paymentType);
  }
  return PM_ONLY_BOOK_FROM_APP_COMPLETED_DRIVER;
};

export const convertPaymentTypeForCompleteWithoutService = (paymentTypeBooking) => {
  let paymentTypeToComplete = paymentTypeBooking;
  switch (paymentTypeBooking) {
    case 1:
      paymentTypeToComplete = 0;
      break;
    case 2:
      paymentTypeToComplete = 1;
      break;
    case 3:
      paymentTypeToComplete = 5;
      break;
    case 4:
      paymentTypeToComplete = 7;
      break;
    case 5:
      paymentTypeToComplete = 6;
      break;
    case 6:
      paymentTypeToComplete = 3;
      break;
    case 8:
      paymentTypeToComplete = 9;
      break;
    case 9:
      paymentTypeToComplete = 10;
      break;
    case 7:
      paymentTypeToComplete = 8;
      break;
  }
  return paymentTypeToComplete;
};

export const checkPaymentShow = (params) => {
  let {
    auth,
    companySelected,
    paymentMethodIndividuals = [],
    paymentMethodCorporates = [],
    corporateSelected,
    traveler_type,
    isDelivery,
    isBookingDetail,
    requestPaymentType
  } = params;
  let newPaymentMethodCorporates = [...paymentMethodCorporates];
  // check show by corporate
  // But only check when operator is corporate
  let isDisableSelectMethodCorp = false;
  if (
    (auth?.user?.userType === userType.CorporateAdmin ||
      auth?.user?.userType === userType.CorporateUser) &&
    traveler_type == TRAVELER_TYPE.Corporate &&
    corporateSelected
  ) {
    newPaymentMethodCorporates = newPaymentMethodCorporates.filter((pm) => {
        if(pm.key === 'credit') return true;
        return (corporateSelected.paymentMethods || []).some(
          (ob) => ob.type === pm.key && ob.isActive
        )
      }
    );
    LOG_BOOK_PAYMENT_FUNC_FILE('filter by setting corporate', newPaymentMethodCorporates)
    // Trường hơp có add ít nhất 1 card => turn on: Corporate card
    if (corporateSelected?.credits?.length > 0) {
      const corpCreditEnable = paymentMethodCorporates.find((pm) => pm.key === 'corpCredit')
      if(corpCreditEnable) {
        newPaymentMethodCorporates.push(corpCreditEnable);
      }
      LOG_BOOK_PAYMENT_FUNC_FILE('Trường hơp có add ít nhất 1 card => turn on: Corporate card', newPaymentMethodCorporates)
    }

    // book delivery nếu bật cash => + cashBysender and cashByRecipient
    if (
      isDelivery &&
      corporateSelected.paymentMethods.some(
        (ob) => ob.type === 'cash' && ob.isActive
      )
    ) {
      if (paymentMethodCorporates.find((pm) => pm.key === 'cashBySender')) {
        newPaymentMethodCorporates.push(
          paymentMethodCorporates.find((pm) => pm.key === 'cashBySender')
        );
      }
      if (paymentMethodCorporates.find((pm) => pm.key === 'cashByRecipient')) {
        newPaymentMethodCorporates.push(
          paymentMethodCorporates.find((pm) => pm.key === 'cashByRecipient')
        );
      }
      LOG_BOOK_PAYMENT_FUNC_FILE('book delivery nếu bật cash => + cashBysender and cashByRecipient', newPaymentMethodCorporates)
    }

    if (isBookingDetail) {
      // only Booking Detail
      // case khong co bat ki payment nao duoc support  => show pm khi tao booking và disable
      if (
        !newPaymentMethodCorporates ||
        newPaymentMethodCorporates.length === 0
      ) {
        isDisableSelectMethodCorp = true;
        LOG_BOOK_PAYMENT_FUNC_FILE('ase khong co bat ki payment nao duoc support  => show pm khi tao booking và disable')
        // case operator admin assign 1 payment nhưng ở operator corp không duoc support
      } else if (
        !newPaymentMethodCorporates?.some(
          (pm) => pm?.value === requestPaymentType
        )
      ) {
        LOG_BOOK_PAYMENT_FUNC_FILE('case operator admin assign 1 payment nhưng ở operator corp không duoc support')
        const obPaymentRequest = paymentMethodCorporates.find(
          (pm) => pm?.value === requestPaymentType
        );
        if (obPaymentRequest?.value) {
          newPaymentMethodCorporates.push(obPaymentRequest);
        }
      }
    }
  }

  return {
    paymentMethodIndividuals: paymentMethodIndividuals,
    paymentMethodCorporates: newPaymentMethodCorporates,
    isDisableSelectMethodCorp,
  };
};

export {
  isPaymentMethodEditable,
  checkAllShowOnlinePayment,
  calulatePreAuthoried,
};
